import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SplashScreen from "./components/SplashScreen";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import DepartmentsPage from "./pages/DepartmentsPage";
import ConsultantsPage from "./pages/ConsultantsPage";
import FacilitiesPage from "./pages/FacilitiesPage";
import InsurancePage from "./pages/InsurancePage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [showSplash, setShowSplash] = useState(() => {
    // Check if splash has been shown before
    return !localStorage.getItem('splashShown');
  });

  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop />
        {showSplash ? (
          <SplashScreen onComplete={() => setShowSplash(false)} />
        ) : (
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/departments" element={<DepartmentsPage />} />
            <Route path="/consultants" element={<ConsultantsPage />} />
            <Route path="/facilities" element={<FacilitiesPage />} />
            <Route path="/insurance" element={<InsurancePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
